import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Field, Form, Formik } from 'formik';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import CategoryIcon from '@material-ui/icons/Category';
import TuneIcon from '@material-ui/icons/Tune';
import StorefrontIcon from '@material-ui/icons/Storefront';
import validationSchema from './validationSchema';
import GreenSwitch from '../../UI/Form/Switch/GreenSwitch';
import UIContainer from '../../UI/Container/UIContainer';
import UIFormTitle from '../../UI/Form/Title/UIFormTitle';
import UIFormContainerSave from '../../UI/Form/ContainerSave/UIFormContainer';
import useApi from '../../../utils/useApi';
import useStorage from '../../../utils/useStorage';
import UIModalOldForm from '../../UI/ModalOldForm/UIModalOldForm';
import { isEqualObject } from '../../../utils/utils';

const useStyles = makeStyles((theme) => ({
  tabRoot: {
    minHeight: 52,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.9rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
      padding: '6px 4px',
      minWidth: 'auto',
    },
  },
  tabContent: {
    padding: theme.spacing(3, 2),
    minHeight: 380,
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 1),
    },
  },
}));

const initialState = {
  name: '',
  description: '',
  customerProfile: '',
  categories: [],
  products: [],
  services: [],
  discountType: 'percentage',
  discount: '',
  percentage: '',
  minValue: '',
  maxDiscount: '',
  startDate: '',
  endDate: '',
  usageLimit: '',
  minQuantity: '',
  interestFree: 'false',
  catalogPublication: 'none',
  couponCode: '',
  paymentMethods: [],
  isActive: true,
};

const PromotionNew = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);
  const [open, setOpen] = useState(false);
  const [oldValues, setOldValues] = useStorage('formPromotion');

  const [registerLoad, registerInfo, setRegisterInfo] = useApi({
    method: 'post',
    url: '/promotions',
  });

  const [categoriesLoad, categoriesInfo] = useApi({
    method: 'get',
    url: '/categories',
  });

  const [productsLoad, productsInfo] = useApi({
    method: 'get',
    url: '/products?lacking=0',
  });

  const [servicesLoad, servicesInfo] = useApi({
    method: 'get',
    url: '/services?isActive=1',
  });

  const [clientLoad, clientInfo] = useApi({
    method: 'get',
    url: '/customers/profiles',
  });

  const [paymentsLoad, paymentsInfo] = useApi({
    method: 'get',
    url: '/payments/methods',
  });

  function changeModal() {
    setOpen(!open);
  }

  function setFormValues() {
    setOldValues(null);
    changeModal();
  }

  function updateStorage(values) {
    setOldValues(values);
  }

  function generateRandomCoupon() {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let code = 'DUZZ';
    for (let i = 0; i < 4; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
  }

  useEffect(() => {
    clientLoad();
    categoriesLoad();
    productsLoad();
    servicesLoad();
    paymentsLoad();
    if (oldValues && !isEqualObject(oldValues, initialState)) {
      changeModal();
    }
  }, []);

  function onSubmit(values) {
    if (values.startDate && values.endDate) {
      if (new Date(values.endDate) <= new Date(values.startDate)) {
        alert('A data de término da vigência deve ser posterior à data de início.');
        return;
      }
    }

    const isPub = values.catalogPublication === 'public';
    const isCoup = values.catalogPublication === 'coupon';

    const isPct = values.discountType === 'percentage';
    const finalPercentage = isPct ? Number(values.percentage) || 0 : 0;
    const finalDiscount = !isPct ? Number(values.discount) || 0 : 0;

    const hasCats = values.categories && values.categories.length > 0;

    const valuesPromotion = {
      name: values.name,
      description: values.description,
      customerProfile: isPub ? 1 : values.customerProfile,
      categories: hasCats ? values.categories.map((c) => (typeof c === 'object' ? c.id : c)) : [],
      products: !hasCats ? values.products.map((product) => (typeof product === 'object' ? product.id : product)) : [],
      services: !hasCats ? values.services.map((service) => (typeof service === 'object' ? service.id : service)) : [],
      percentage: finalPercentage,
      discount: finalDiscount,
      minValue: values.minValue !== '' && values.minValue !== null ? Number(values.minValue) : null,
      maxDiscount: values.maxDiscount !== '' && values.maxDiscount !== null ? Number(values.maxDiscount) : null,
      startDate: values.startDate ? values.startDate : null,
      endDate: values.endDate ? values.endDate : null,
      usageLimit: values.usageLimit !== '' && values.usageLimit !== null ? parseInt(values.usageLimit, 10) : null,
      minQuantity: values.minQuantity !== '' && values.minQuantity !== null ? parseInt(values.minQuantity, 10) : null,
      interestFree: values.interestFree === 'true' || values.interestFree === true,
      isPublic: isPub,
      couponCode: isCoup && values.couponCode ? values.couponCode.trim().toUpperCase() : null,
      paymentMethods: values.paymentMethods
        ? values.paymentMethods.map((p) => (typeof p === 'object' ? p.id : p))
        : [],
      isActive: Boolean(values.isActive),
    };

    registerLoad({
      data: valuesPromotion,
    });
  }

  const externalPaymentMethods = paymentsInfo.data
    ? paymentsInfo.data.filter((pm) => Number(pm.is_internal) !== 1)
    : [];

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={oldValues || initialState}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ setFieldValue, errors, touched, values }) => (
          <Form onBlur={() => updateStorage(values)}>
            <UIContainer container direction="row">
              <Grid
                item
                xs={12}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  paddingBottom: 8,
                }}
              >
                <UIFormTitle title="Nova promoção" />
              </Grid>

              <Grid item xs={12}>
                <Box borderBottom={1} borderColor="divider" bgcolor="#fbfcfd" style={{ borderRadius: '4px 4px 0 0' }}>
                  <Tabs
                    value={tab}
                    onChange={(e, val) => setTab(val)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                  >
                    <Tab
                      className={classes.tabRoot}
                      icon={<LocalOfferIcon fontSize="small" />}
                      label="Geral & Desconto"
                    />
                    <Tab
                      className={classes.tabRoot}
                      icon={<CategoryIcon fontSize="small" />}
                      label="Itens Elegíveis"
                    />
                    <Tab
                      className={classes.tabRoot}
                      icon={<TuneIcon fontSize="small" />}
                      label="Regras & Vigência"
                    />
                    <Tab
                      className={classes.tabRoot}
                      icon={<StorefrontIcon fontSize="small" />}
                      label="Loja Virtual"
                    />
                  </Tabs>
                </Box>
              </Grid>

              <Grid item xs={12} className={classes.tabContent}>
                {/* ABA 0: GERAL & DESCONTO */}
                {tab === 0 && (
                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12} md={8}>
                      <Field
                        name="name"
                        label="Nome da Promoção"
                        error={Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                        placeholder="Informe o nome da promoção"
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <FormControlLabel
                        label={
                          values.isActive
                            ? 'Promoção ativa'
                            : 'Promoção inativa'
                        }
                        labelPlacement="top"
                        control={
                          <GreenSwitch
                            checked={values.isActive}
                            onChange={(ev) =>
                              setFieldValue('isActive', ev.target.checked)
                            }
                          />
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <Field
                        name="description"
                        label="Descrição (Opcional)"
                        error={Boolean(errors.description)}
                        helperText={touched.description && errors.description}
                        placeholder="Informe a descrição da promoção"
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth>
                        <InputLabel shrink id="promotion-new-customerProfile">
                          Perfil do cliente
                        </InputLabel>
                        <Field
                          name="customerProfile"
                          disabled={clientInfo.loading || values.catalogPublication === 'public'}
                          error={Boolean(errors.customerProfile)}
                          helperText={
                            values.catalogPublication === 'public'
                              ? 'Ofertas públicas se aplicam ao perfil padrão (1).'
                              : (touched.customerProfile && errors.customerProfile)
                          }
                          labelId="promotion-new-customerProfile"
                          displayEmpty
                          fullWidth
                          as={Select}
                          value={values.catalogPublication === 'public' ? 1 : values.customerProfile}
                        >
                          <MenuItem disabled value="">
                            <em>Selecione o perfil do cliente</em>
                          </MenuItem>
                          {clientInfo.data !== null &&
                            clientInfo.data.map((client) => (
                              <MenuItem key={client.id} value={client.id}>
                                {client.name}
                              </MenuItem>
                            ))}
                        </Field>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend" style={{ fontSize: '0.85rem', color: '#17497F', fontWeight: 600 }}>
                          Tipo de Desconto Concedido
                        </FormLabel>
                        <RadioGroup
                          row
                          value={values.discountType || 'percentage'}
                          onChange={(ev) => {
                            const newType = ev.target.value;
                            setFieldValue('discountType', newType);
                            if (newType === 'percentage') {
                              setFieldValue('discount', '');
                            } else {
                              setFieldValue('percentage', '');
                              setFieldValue('maxDiscount', '');
                            }
                          }}
                        >
                          <FormControlLabel
                            value="percentage"
                            control={<Radio color="primary" />}
                            label="Porcentagem (%)"
                          />
                          <FormControlLabel
                            value="discount"
                            control={<Radio color="primary" />}
                            label="Valor Fixo (R$)"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend" style={{ fontSize: '0.85rem', color: '#17497F', fontWeight: 600 }}>
                          Remover juros no parcelamento?
                        </FormLabel>
                        <RadioGroup
                          row
                          value={String(values.interestFree)}
                          onChange={(ev) =>
                            setFieldValue('interestFree', ev.target.value)
                          }
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Sim"
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="Não"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {values.discountType === 'percentage' ? (
                      <>
                        <Grid item xs={12} md={6}>
                          <Field
                            name="percentage"
                            label="Desconto em Porcentagem (%)"
                            error={Boolean(errors.percentage)}
                            helperText={
                              (touched.percentage && errors.percentage) ||
                              'Aplica % de desconto sobre o valor dos itens participantes.'
                            }
                            placeholder="Ex: 10 (para 10% de desconto)"
                            type="number"
                            inputProps={{ min: 0, max: 100, step: 'any' }}
                            fullWidth
                            as={TextField}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Field
                            name="maxDiscount"
                            label="Teto Máximo de Desconto em R$ (Opcional)"
                            error={Boolean(errors.maxDiscount)}
                            helperText={
                              (touched.maxDiscount && errors.maxDiscount) ||
                              'Ex: 50.00. Limita o desconto máximo mesmo em compras grandes.'
                            }
                            placeholder="Sem limite de teto"
                            type="number"
                            inputProps={{ min: 0, step: 'any' }}
                            fullWidth
                            as={TextField}
                          />
                        </Grid>
                      </>
                    ) : (
                      <Grid item xs={12} md={6}>
                        <Field
                          name="discount"
                          label="Desconto Fixo (R$)"
                          error={Boolean(errors.discount)}
                          helperText={
                            (touched.discount && errors.discount) ||
                            'Abate este valor do total dos itens participantes.'
                          }
                          placeholder="Ex: 15.00 (para R$ 15,00 de desconto)"
                          type="number"
                          inputProps={{ min: 0, step: 'any' }}
                          fullWidth
                          as={TextField}
                        />
                      </Grid>
                    )}
                  </Grid>
                )}

                {/* ABA 1: ITENS ELEGÍVEIS */}
                {tab === 1 && (
                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 4 }}>
                        Defina os itens participantes. Ao selecionar categorias, todos os produtos e serviços vinculados a elas participarão automaticamente da promoção.
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Autocomplete
                        multiple
                        noOptionsText="Sem opções"
                        disabled={categoriesInfo.loading}
                        options={categoriesInfo.data !== null ? categoriesInfo.data : []}
                        value={
                          values.categories && values.categories.length > 0
                            ? (categoriesInfo.data || []).filter((cat) =>
                              values.categories.some((val) => String(typeof val === 'object' ? val.id : val) === String(cat.id))
                            )
                            : []
                        }
                        getOptionLabel={(cat) => cat.name || `Categoria #${cat.id}`}
                        getOptionSelected={(option, value) =>
                          String(option.id) === String(typeof value === 'object' ? value.id : value)
                        }
                        onChange={(event, cats) => {
                          setFieldValue('categories', cats);
                          if (cats && cats.length > 0) {
                            setFieldValue('products', []);
                            setFieldValue('services', []);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Categorias participantes (Opcional)"
                            variant="standard"
                            placeholder={
                              !values.categories || !values.categories.length ? 'Nenhuma categoria (Definir por produtos/serviços ou todos)' : 'Adicione mais categorias'
                            }
                            helperText={
                              values.categories && values.categories.length > 0
                                ? 'Categorias selecionadas. Os campos de produtos e serviços individuais abaixo foram desabilitados.'
                                : 'Deixe vazio caso queira selecionar produtos ou serviços específicos abaixo.'
                            }
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Autocomplete
                        multiple
                        noOptionsText="Sem opções"
                        disabled={productsInfo.loading || (values.categories && values.categories.length > 0)}
                        options={
                          productsInfo.data !== null ? productsInfo.data : []
                        }
                        value={
                          values.products && values.products.length > 0
                            ? (productsInfo.data || []).filter((prod) =>
                              values.products.some((val) => String(typeof val === 'object' ? val.id : val) === String(prod.id))
                            )
                            : []
                        }
                        getOptionLabel={(product) => product.name || `Produto #${product.id}`}
                        getOptionSelected={(option, value) =>
                          String(option.id) === String(typeof value === 'object' ? value.id : value)
                        }
                        onChange={(event, products) =>
                          setFieldValue('products', products)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Produtos participantes (Opcional)"
                            error={Boolean(errors.products)}
                            helperText={
                              values.categories && values.categories.length > 0
                                ? 'Desabilitado por categoria'
                                : (touched.products && errors.products) || 'Deixe vazio para todos os produtos se não houver categoria.'
                            }
                            variant="standard"
                            placeholder={
                              values.categories && values.categories.length > 0
                                ? 'Desabilitado por categoria'
                                : (!values.products || !values.products.length ? 'Válido para todos os produtos' : 'Adicione mais produtos')
                            }
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Autocomplete
                        multiple
                        noOptionsText="Sem opções"
                        disabled={servicesInfo.loading || (values.categories && values.categories.length > 0)}
                        options={
                          servicesInfo.data !== null ? servicesInfo.data : []
                        }
                        value={
                          values.services && values.services.length > 0
                            ? (servicesInfo.data || []).filter((serv) =>
                              values.services.some((val) => String(typeof val === 'object' ? val.id : val) === String(serv.id))
                            )
                            : []
                        }
                        getOptionLabel={(service) => service.name || `Serviço #${service.id}`}
                        getOptionSelected={(option, value) =>
                          String(option.id) === String(typeof value === 'object' ? value.id : value)
                        }
                        onChange={(event, services) =>
                          setFieldValue('services', services)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Serviços participantes (Opcional)"
                            error={Boolean(errors.services)}
                            helperText={
                              values.categories && values.categories.length > 0
                                ? 'Desabilitado por categoria'
                                : (touched.services && errors.services) || 'Deixe vazio para todos os serviços se não houver categoria.'
                            }
                            variant="standard"
                            placeholder={
                              values.categories && values.categories.length > 0
                                ? 'Desabilitado por categoria'
                                : (!values.services || !values.services.length ? 'Válido para todos os serviços' : 'Adicione mais serviços')
                            }
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                )}

                {/* ABA 2: REGRAS & VIGÊNCIA */}
                {tab === 2 && (
                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 4 }}>
                        Configure critérios adicionais para que a promoção possa ser utilizada:
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Field
                        name="minValue"
                        label="Valor Mínimo da Compra (R$) - Opcional"
                        error={Boolean(errors.minValue)}
                        helperText={
                          (touched.minValue && errors.minValue) ||
                          'O pedido deve atingir ao menos este valor para liberar a promoção.'
                        }
                        placeholder="Ex: 50.00"
                        type="number"
                        inputProps={{ min: 0, step: 'any' }}
                        fullWidth
                        as={TextField}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Field
                        name="minQuantity"
                        label="Quantidade Mínima de Itens - Opcional"
                        error={Boolean(errors.minQuantity)}
                        helperText={
                          (touched.minQuantity && errors.minQuantity) ||
                          'Quantidade mínima de itens participantes exigida.'
                        }
                        placeholder="Ex: 2"
                        type="number"
                        inputProps={{ min: 1, step: 1 }}
                        fullWidth
                        as={TextField}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Field
                        name="usageLimit"
                        label="Limite Máximo de Utilizações (Opcional)"
                        error={Boolean(errors.usageLimit)}
                        helperText={
                          (touched.usageLimit && errors.usageLimit) ||
                          'Número total de vendas em que esta promoção pode ser usada.'
                        }
                        placeholder="Ex: 100 (Uso ilimitado se vazio)"
                        type="number"
                        inputProps={{ min: 1, step: 1 }}
                        fullWidth
                        as={TextField}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Field
                        name="startDate"
                        label="Início da Vigência"
                        error={Boolean(errors.startDate)}
                        helperText={touched.startDate && errors.startDate}
                        type="datetime-local"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        as={TextField}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Field
                        name="endDate"
                        label="Término da Vigência"
                        error={Boolean(errors.endDate)}
                        helperText={touched.endDate && errors.endDate}
                        type="datetime-local"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        as={TextField}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Autocomplete
                        multiple
                        noOptionsText="Sem opções"
                        disabled={paymentsInfo.loading}
                        options={externalPaymentMethods}
                        getOptionSelected={(option, value) =>
                          String(option.id) === String(typeof value === 'object' ? value.id : value)
                        }
                        value={
                          values.paymentMethods && values.paymentMethods.length > 0
                            ? externalPaymentMethods.filter((pm) =>
                              values.paymentMethods.some((val) => String(typeof val === 'object' ? val.id : val) === String(pm.id))
                            )
                            : []
                        }
                        getOptionLabel={(option) => option.name || `Forma #${option.id}`}
                        onChange={(event, selected) => setFieldValue('paymentMethods', selected)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Limitar a certas formas de pagamento (Opcional)"
                            placeholder={!values.paymentMethods || !values.paymentMethods.length ? 'Válido para todas as formas de pagamento' : 'Adicione mais'}
                            helperText="Selecione caso a promoção ou cupom só tenha validade para pagamentos específicos (ex: PIX)."
                            variant="standard"
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                )}

                {/* ABA 3: LOJA VIRTUAL */}
                {tab === 3 && (
                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 4 }}>
                        Toda promoção criada é válida para uso manual no PDV. Escolha abaixo como ela será disponibilizada na vitrine online:
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend" style={{ fontSize: '0.85rem', color: '#17497F', fontWeight: 600 }}>
                          Modo de Publicação na Loja
                        </FormLabel>
                        <RadioGroup
                          value={values.catalogPublication || 'none'}
                          onChange={(ev) => {
                            const mode = ev.target.value;
                            setFieldValue('catalogPublication', mode);
                            if (mode === 'public') {
                              setFieldValue('customerProfile', 1);
                            }
                            if (mode !== 'coupon') {
                              setFieldValue('couponCode', '');
                            }
                          }}
                        >
                          <FormControlLabel
                            value="none"
                            control={<Radio color="primary" />}
                            label="Não publicar na loja (Uso manual no PDV)"
                          />
                          <FormControlLabel
                            value="public"
                            control={<Radio color="primary" />}
                            label="Oferta Pública (Exibe preço com desconto e selo de oferta na vitrine)"
                          />
                          <FormControlLabel
                            value="coupon"
                            control={<Radio color="primary" />}
                            label="Cupom de Desconto (Exige que o cliente digite o código no carrinho)"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {values.catalogPublication === 'coupon' && (
                      <Grid item xs={12} md={6} container spacing={1} alignItems="center">
                        <Grid item xs={8}>
                          <Field
                            name="couponCode"
                            label="Código do Cupom"
                            error={Boolean(errors.couponCode)}
                            helperText={touched.couponCode && errors.couponCode}
                            placeholder="Ex: VERAO10, DUZZ20"
                            fullWidth
                            as={TextField}
                            inputProps={{ style: { textTransform: 'uppercase' } }}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            onClick={() => setFieldValue('couponCode', generateRandomCoupon())}
                          >
                            Gerar Cupom
                          </Button>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                )}
              </Grid>
            </UIContainer>

            <UIFormContainerSave
              container
              justify="center"
              direction="row"
              messageSucess="Promoção cadastrada com sucesso"
              messageError="Alguma coisa está errada, verifique os campos"
              error={registerInfo.error}
              loading={registerInfo.loading || ''}
              data={registerInfo.data}
              setrequestinfo={setRegisterInfo}
              setFormValues={() => setOldValues(null)}
            />

            <UIModalOldForm
              open={open}
              changeModal={changeModal}
              setFormValues={setFormValues}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default PromotionNew;
